// extracted by mini-css-extract-plugin
export default {"main":"PostMonitoring_main__Wq1Vf","actions":"PostMonitoring_actions__RxYjT"};